import script from "./Iframe.vue?vue&type=script&setup=true&lang=ts"
export * from "./Iframe.vue?vue&type=script&setup=true&lang=ts"

import "./Iframe.vue?vue&type=style&index=0&id=a793feac&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a793feac"]])

export default __exports__